import { render, staticRenderFns } from "./TheDefaultLayout.vue?vue&type=template&id=3b6a4374&scoped=true"
import script from "./TheDefaultLayout.vue?vue&type=script&lang=js"
export * from "./TheDefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./TheDefaultLayout.vue?vue&type=style&index=0&id=3b6a4374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a4374",
  null
  
)

export default component.exports